(function () {
  'use strict';

  angular.module('app').component('tickets', ticketsComponent());

  function ticketsComponent() {
    return {
      bindings: {},
      controller: TicketsCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/tickets/tickets.component.html',
    };
  }

  TicketsCtrl.$inject = [
    'CONFIGURATIONS',
    '$routeParams',
    '$translate',
    'TicketsService',
    'BookingService',

    // Angular downgraded service
    'ng2Router',
  ];

  function TicketsCtrl(
    config,
    $routeParams,
    $translate,
    TicketsService,
    BookingService,

    // Angular downgraded service
    ng2Router
  ) {
    const vm = this;

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY_24;

    vm.option = $routeParams.option;

    let id = $routeParams.id; // booking_id / booking_item_id
    let subdomain = $routeParams.subdomain;
    let companyApiKey = $routeParams.companyApiKey;
    let lang = $routeParams.lang;

    if (vm.option !== 'itinerary' && vm.option !== 'voucher') {
      ng2Router.navigate(['/ng/login']);
      return;
    }

    vm.$onInit = function () {
      // if ($translate.use() !== lang){
      $translate.use(lang);
      // }

      // var d = moment('2015-05-15', 'YYYY-MM-DD');
      // d.format('YYYY/MM/DD');

      // console.log('lang:', lang);
      // console.log(d);

      // let momentObj = moment('04. Juli 2016 05:00', 'LLL', 'de');
      // console.log(momentObj);

      getTicket(vm.option);
    };

    vm.getTotalPax = function (adults, children, infants, seniors, option) {
      return BookingService.getTotalPax(adults, children, infants, seniors, option);
    };

    function getTicket(option) {
      TicketsService.getTicket(option, id, subdomain, companyApiKey, lang).then(function (data) {
        if (data) {
          vm.company = data.company;
          vm.website = data.website;
          vm.booking = data.booking;
          vm.guest = data.booking.guests.find((item) => item.is_default === true);

          // console.log(vm.website);

          if (option === 'voucher') {
            vm.bookingItem = data.booking_item;

            vm.itemDetailName = vm.bookingItem.detail.content
              ? vm.bookingItem.detail.content.name
              : vm.bookingItem.detail.name;

            vm.totalPax = BookingService.getTotalPax(
              vm.bookingItem.adults,
              vm.bookingItem.children,
              vm.bookingItem.infants,
              vm.bookingItem.seniors,
              'long'
            );
          }
          /*else if(option === 'itinerary'){
                        vm.automatic = data.automatic;
                    }*/
        } else {
          ng2Router.navigate(['/ng/login']);
        }
      });
    }
  }
})();
